export const isValidArray = (arr) => {
    return Array(arr) && arr?.length > 0
}